__turbopack_context__.v({
  "searchButton": "search-button-module__9LsXUW__searchButton",
  "searchRoot": "search-button-module__9LsXUW__searchRoot",
});
